<template>
  <div>
    <label v-if="textLabel" class="typo__label">{{ textLabel }}</label>
    <multiselect
      placeholder=""
      class="uk-form-controls uk-text-small"
      v-bind="$attrs"
      :options="options || []"
      :show-labels="false"
      tag-placeholder=""
    >
      <template v-for="(_, slotName) in $slots" :key="slotName" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps"></slot>
      </template>
    </multiselect>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Multiselect from 'vue-multiselect';

export default defineComponent({
  name: 'FilterSelector',
  components: { Multiselect },
  inheritAttrs: false,
  props: {
    textLabel: String,
    options: {
      type: Array,
      default: () => [],
    }
  }
});
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: 13px;
}
.multiselect__tags {
  background: #e5eaff !important;
}
.multiselect__single {
  background: #e5eaff;
}
</style>